import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { LoginCompany, LoginCompanyUserInfo } from '@/common/types/login';

interface CompanyState {
  activeCompanyUser: LoginCompanyUserInfo | null;
  activeCompany: LoginCompany | null;
  companies: LoginCompanyUserInfo[];
  setActiveCompany: (company: LoginCompany | null) => void;
  setActiveCompanyUser: (companyUser: LoginCompanyUserInfo | null) => void;
  setCompanies: (companies: LoginCompanyUserInfo[]) => void;
  clearCompanyState: () => void;
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      activeCompany: null,
      activeCompanyUser: null,
      companies: [],
      setActiveCompany: (company) => set({ activeCompany: company }),
      setActiveCompanyUser: (companyUser) => set({ activeCompanyUser: companyUser }),
      setCompanies: (companies) => set({ companies }),
      clearCompanyState: () => set({ activeCompany: null, activeCompanyUser: null, companies: [] }),
    }),
    {
      name: 'company-storage',
    }
  )
);